module.exports = __webpack_public_path__ + "img/Chlamydomonas_reinhardtii.82499ad8.jpg";